export default "__VITE_ASSET__am8IYORx__"